import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Client } from '../../../client/classes/client';

@Component({
    selector: 'kiene-vvvo-card',
    templateUrl: './vvvo-card.component.html',
    styleUrls: ['./vvvo-card.component.scss'],
})
export class VvvoCardComponent {
    @Input() vvvo!: Client;

    /** When true, hides the action menu (e.g. read-only Standard-Schlachthof display). */
    @Input() hideActions = false;

    @Output() bearbeiten = new EventEmitter<Client>();
    @Output() entfernen = new EventEmitter<Client>();
    @Output() sendMail = new EventEmitter<Client>();
    @Output() freigabePraxis = new EventEmitter<Client>();

    getVollAdresse(vvvo: Client): string {
        if (!vvvo.strasse && !vvvo.plz && !vvvo.ort) {
            return '';
        }
        return `${vvvo.strasse || ''}${vvvo.strasse && (vvvo.plz || vvvo.ort) ? ', ' : ''}${vvvo.plz || ''} ${vvvo.ort || ''}`.trim();
    }

    getLieferadresse(vvvo: Client): string {
        if (vvvo.abweichende_lieferadresse <= 0) {
            return '';
        }
        return `${vvvo.strasse_lieferung || ''}${vvvo.strasse_lieferung && (vvvo.plz_lieferung || vvvo.ort_lieferung) ? ', ' : ''}${vvvo.plz_lieferung || ''} ${vvvo.ort_lieferung || ''}`.trim();
    }

    onBearbeiten(): void {
        this.bearbeiten.emit(this.vvvo);
    }

    onEntfernen(): void {
        this.entfernen.emit(this.vvvo);
    }

    onSendMail(): void {
        this.sendMail.emit(this.vvvo);
    }

    onFreigabePraxis(): void {
        this.freigabePraxis.emit(this.vvvo);
    }
}
